import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { styled } from "@mui/material";
import Rating from "@mui/material/Rating";
import React from "react";

import { useLogging } from "../logging/useLogging";
import { AppEvent, ExerciseId } from "../types";

interface ExcludeProps {
    handleClick: (id: ExerciseId, value: number | null) => void;
    id: ExerciseId;
    excluded: ReadonlyArray<ExerciseId>;
    favourites: ReadonlyArray<ExerciseId>;
}

const Exclude: React.FunctionComponent<ExcludeProps> = ({ excluded, favourites, id, handleClick }) => {
    const { logWithPayload } = useLogging();

    const handleClickWithLogging = (value: number | null) => {
        handleClick(id, value);
        logWithPayload(value ? AppEvent.ExcludedAdded : AppEvent.ExcludedRemoved, { id });
    };
    return (
        <StyledRating
            name="exclude"
            value={excluded.includes(id) ? 1 : 0}
            max={1}
            icon={<ThumbDownIcon fontSize="inherit" />}
            emptyIcon={<ThumbDownOffAltIcon fontSize="inherit" />}
            onChange={(_, value) => handleClickWithLogging(value)}
            disabled={favourites.includes(id)}
        />
    );
};

export default Exclude;

export const StyledRating = styled(Rating)({
    marginLeft: 10,
    "& .MuiRating-iconFilled": {
        color: "#6d75ff",
    },
});
